import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import siteQueries from '../../queries/siteQueries';
import { BASE_URL } from '../../apis/api';
import MainHeader from './MainHeader';
import Footer from './Footer';
import Loader from './Loader';
import BannerBg from '../../images/cover/inner-banner-bg.jpg';
import { useScrollToTop } from '../../hooks/ScrollTop';

const NewsViewSite = () => {
    const [news, setNews] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(4);
    const [newsview, setNewsview] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const { id } = useParams();

    const newsData = siteQueries.useNewsMutation(
        async (response) => {
            setNews(response?.data?.items);
        },
    );

    useEffect(() => {
        newsData.mutateAsync({
            page: currentPage,
            size: pageSize,
        })
    }, [])

    const newsDataview = siteQueries.useNewsviewsiteMutation(
        async (response) => {
            setNewsview(response?.data);
            setIsLoading(false);
        },
    );

    useEffect(() => {
        if (id) {
            setIsLoading(true);
            newsDataview.mutateAsync({ id });
        }
    }, [id]);

    const handleReadMore = (item) => {
        window.scrollTo(0, 0);
         navigate(`/newsviewsite/${item.id}/${item.shortdescription}`);
    }

    const decodeHtml = (html) => {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    };
useScrollToTop()
    return (
        <div className="min-h-screen bg-gray-50">
            <MainHeader />
            
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {/* Hero Banner */}
                    <div 
                        className="min-h-[190px] flex justify-center items-center py-4 relative overflow-hidden"
                        style={{
                            backgroundImage: `url(${BannerBg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        {/* Dark overlay for better text readability */}
                        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
                        
                        <div className="relative z-10 text-center px-4">
                            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold drop-shadow-lg">
                                <span className="text-yellow-400">
                                    {newsview?.shortdescription}
                                </span>
                            </h1>
                        </div>
                    </div>
                    
                    {/* Main Content */}
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                            {/* Main Article */}
                            <div className="lg:col-span-2">
                                <div className="relative rounded-lg shadow-lg overflow-hidden">
                                    {/* Blurred Background Image */}
                                    <div
                                        className="absolute inset-0 z-0 bg-cover bg-center"
                                        style={{
                                            backgroundImage: `url(${BASE_URL}/${newsview?.image})`,
                                            filter: 'blur(12px)',
                                            opacity: 0.3
                                        }}
                                    ></div>

                                    {/* Content Overlay */}
                                    <div className="relative z-10">
                                        {/* Image Section */}
                                        <div className="w-full flex justify-center items-center p-6 pb-0">
                                            <img
                                                src={`${BASE_URL}/${newsview?.image}`}
                                                alt={newsview?.shortdescription}
                                                className="w-full h-auto object-contain max-h-96 rounded-lg shadow-md"
                                            />
                                        </div>
                                        
                                        {/* Text Content Section */}
                                        <div className="bg-white bg-opacity-95 backdrop-blur-sm p-6 m-4 rounded-lg">
                                            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                                                {newsview?.shortdescription}
                                            </h2>
                                            <div className="prose prose-sm sm:prose-base md:prose-lg max-w-none text-gray-700">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: decodeHtml(newsview?.maindescription),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sidebar Articles */}
                            <div className="lg:col-span-1">
                                <div className="sticky top-4">
                                    <h3 className="text-lg font-semibold text-gray-900 mb-4">
                                        Related News
                                    </h3>
                                    <div className="space-y-4">
                                        {news?.filter(item => item.id !== newsview.id).map((item, index) => (
                                            <div 
                                                key={index}
                                                className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-200"
                                                onClick={() => handleReadMore(item)}
                                            >
                                                <div className="w-full p-3">
                                                    <img
                                                        src={`${BASE_URL}/${item?.image}`}
                                                        alt={item?.shortdescription}
                                                        className="w-full h-auto object-contain max-h-32 rounded"
                                                    />
                                                </div>
                                                <div className="p-4 pt-0">
                                                    <h4 className="text-sm sm:text-base font-semibold text-gray-900 mb-2 line-clamp-2">
                                                        {item?.shortdescription}
                                                    </h4>
                                                    <div className="text-xs sm:text-sm text-gray-600 line-clamp-3">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: decodeHtml(item?.maindescription)
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            
            <Footer />
        </div>
    );
};

export default NewsViewSite;